import Vue from 'vue'
import VueRouter from 'vue-router'
// import Index from '../views/simpleV/index/index.vue'

Vue.use(VueRouter)

const routes = [
 

  {
    path: '/',  //首页
    redirect: '/home',
    component: () => import('../views/EKX/index'),
    children:[
      {
        path: 'home',  //首页
        component: () => import('../views/EKX/home/index.vue'),
        meta:{
          headShow:true
        },
      },
      {
        path: 'about',  //关于我们
        component: () => import('../views/EKX/abouts/index.vue'),
        meta:{
          headShow:true
        },
      },
      {
        path: 'product',  //产品中心
        component: () => import('../views/EKX/product/index.vue'),
         redirect: '/product/page',
        meta:{
          headShow:true
        },
        children:[

            {
                path: 'page',  //产品首页
                component: () => import('../views/EKX/product/page.vue'),
                meta:{
                  headShow:true
                },
            },


          {
                path: 'details',  //产品详情
                component: () => import('../views/EKX/productDetails/index.vue'),
                meta:{
                  headShow:true
                },
          }
        ]
      },
      {
        path: 'case',  //客户案例
        component: () => import('../views/EKX/case/index.vue'),
        meta:{
          headShow:true
        },
      },
      {
        path: 'contact',  //联系我们
        component: () => import('../views/EKX/contact/index.vue'),
        meta:{
          headShow:true
        },
      },
    ]
  },


  // {
  //   path: '/video',  //cim首页
  //   component: () => import('../components/CimComponents/head/video.vue'),
   
  // }
  



  

]





const router = new VueRouter({
  routes,
  scrollBehavior(to, from, saveScrollPosition) {
    return { x: 0, y: 0 };
  },
})

export default router
